"use client";

import { useState } from "react";
import ICON_ARROW_UP from "@/assets/images/arrow-up.svg";
import HOT_ICON from "@/assets/images/hot.svg";

export const BOLT_V26_COLS =
  "grid-cols-[minmax(0,14fr)_minmax(0,28fr)_minmax(0,16fr)_minmax(0,16fr)_minmax(148px,18fr)_minmax(0,8fr)]";

export const BOLT_V26_KETQUA_COLS =
  "grid-cols-[minmax(0,14fr)_minmax(0,26fr)_minmax(0,18fr)_minmax(0,18fr)_minmax(158px,26fr)]";

export default function BoltMatchLeagues({ league, matches = [], render = () => null }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const name = league?.nameVN ?? league?.name ?? "";
  const list = matches || [];

  return (
    <div className="kbv-v26-league-group flex flex-col min-h-0">
      <div className="kbv-v26-league-head">
        <button
          type="button"
          className="kbv-v26-league-head-btn"
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          <div className="flex min-w-0 flex-1 items-center gap-1">
            {league?.logo ? (
              <img
                src={league.logo}
                alt=""
                className="w-5 h-5 object-contain shrink-0"
                width={20}
                height={20}
              />
            ) : (
              <span className="w-5 h-5 shrink-0" />
            )}
            <span className="truncate text-sm font-semibold text-[var(--theme-text)]">
              {name}
            </span>
            {league?.isHot ? (
              <img
                src={HOT_ICON}
                alt="HOT"
                width={50}
                height={18}
                className="h-[18px] w-[50px] shrink-0"
              />
            ) : null}
          </div>
          <img
            className={`kbv-v26-league-chevron w-6 h-6 shrink-0 transition-transform ${isExpanded ? "rotate-180" : ""}`}
            src={ICON_ARROW_UP}
            alt=""
            width={24}
            height={24}
          />
        </button>
      </div>

      {isExpanded ? (
        <div className="flex flex-col min-h-0">
          {list.map((match, idx) => (
            <div key={match.id || idx}>{render(match, idx)}</div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
